import { decorate, observable } from 'mobx';
import { ParentStore } from '@mq/voltron-parent';

class ProgramFundingSourceStore extends ParentStore {
  constructor(args: Object = {}) {
    super(args);
    this.load(args);
  }
  // values
  name: string = '';
  active: boolean = false;
  token: string = '';
  created_time: string = '';
  last_modified_time: string = '';
  account: string = '';
}

decorate(ProgramFundingSourceStore, {
  // values
  name: observable,
  active: observable,
  token: observable,
  created_time: observable,
  last_modified_time: observable,
  account: observable,
});

export default ProgramFundingSourceStore;
